module.exports = __webpack_public_path__ + "static/img/sub-page02@w.536c731.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/discover/sub-page02@w.jpg
// module id = r5pn
// module chunks = 0